import React, { useCallback, useEffect } from "react"

export const CrispChatHelper = ({ children }) => {
  const [initialized, setInitialized] = React.useState(false)
  const [welcomed, setWelcomed] = React.useState(false)
  const [email, setEmail] = React.useState("")
  const [phoneNumber, setPhoneNumber] = React.useState("")
  const [name, setName] = React.useState("")
  const [address, setAddress] = React.useState("")
  const [$crisp, set$crisp] = React.useState(null)


  useEffect(() => {
    if (initialized) {
      return
    }
    const check = () => {
      try {
        const _crisp = window["$crisp"]
        if (!_crisp.get("user:nickname")) {
          _crisp.push(["do", "session:reset"])
        }
        clearInterval(checkInterval)
        set$crisp(_crisp)
        setInitialized(true)
      } catch (e) {
      }
    }

    check()
    const checkInterval = setInterval(check, 100)
    return () => clearInterval(checkInterval)
  }, [initialized])

  useEffect(() => {
    if (!$crisp) return

    $crisp.push(["on", "message:received", function(message) {
      const id = message && message.content && message.content.id
      if (message.type === "field") {
        switch (id) {
          case "field-email":
            setEmail(message.content.value)
            break
          case "field-phone":
            setPhoneNumber(message.content.value)
            break
          case "field-name":
            setName(message.content.value)
            break
          case "field-address":
            setAddress(message.content.value)
            break
          default:
            break
        }
      }
    }])

  }, [$crisp, email, phoneNumber, name, address, setEmail, setPhoneNumber, setName, setAddress])

  useEffect(() => {
    if (!$crisp) return
    if (welcomed) return
    $crisp.push(["do", "message:show", ["text", "Hello! We look forward to working with you! Let's get started."]])
    setTimeout(() => {
      $crisp.push(["do", "message:show", ["field", {
        "id": "field-name",
        "text": "What is your name?",
        "explain": "Enter your name..."
      }]])
    }, 2000)
    setWelcomed(true)

  }, [$crisp, welcomed])

  useEffect(() => {
    if (!$crisp) return
    if (!name) return
    $crisp.push(["set", "user:nickname", [name]])
    $crisp.push(["do", "message:send", ["text", name]])
    $crisp.push(["do", "message:show", ["field", {
      "id": "field-address",
      "text": "What is the property address?",
      "explain": "Enter the property address you are selling..."
    }]])
  }, [$crisp, name])


  useEffect(() => {
    if (!$crisp) return
    if (!address) return
    $crisp.push(["do", "message:send", ["text", address]])
    $crisp.push(["do", "message:show", ["field", {
      "id": "field-phone",
      "text": "What is your phone number?",
      "explain": "Enter your phone number..."
    }]])

  }, [$crisp, address])

  useEffect(() => {
    if (!$crisp) return
    if (!phoneNumber) return

    try {
      $crisp.push(["set", "user:phone", [phoneNumber]])
    } catch (e) {
      console.error("Error setting phone number in Crisp", e)
    }

    $crisp.push(["do", "message:send", ["text", phoneNumber]])
    $crisp.push(["do", "message:show", ["field", {
      "id": "field-email",
      "text": "What is the best email to contact you?",
      "explain": "Enter your email..."
    }]])
  }, [$crisp, phoneNumber])

  useEffect(() => {
    if (!$crisp) return
    if (!email) return

    try {
      $crisp.push(["set", "user:email", [email]])
    } catch (e) {
      console.error("Error setting email in Crisp", e)
    }

    $crisp.push(["do", "message:send", ["text", email]])
    $crisp.push(["do", "message:show", ["text", `Thanks for your information, ${name}. 
    We will get back to you soon!`]])
  }, [$crisp, email, name])


  return React.Fragment
}

